<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardPopupImg
        :cardContent="content"
        :cardType="cardType2"
        :isModalVisible="isShow"
        @updateUser="updateUser"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CardPopupImg from "../../components/template/Chinese1/CardPopupImg";
import "../../assets/scss/_chineseModalCustom.scss";
import "../../assets/scss/_chineseStyle.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";

export default {
  components: { CardPopupImg, LoadingMDL },
  name: "LKI01",
  data() {
    return {
      code: "",
      lang: "",
      content: {},
      cardType2: "img",
      isShow: true,
      CheckWidth: window.innerWidth.toString(),
      baseUrl: process.env.VUE_APP_URL_SOUND,
      sound: "",
      courseSection: "",
      startTime: "",
      courseCode: "",
      condition: [],
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      getUserTemplate: "template/getUserTemplate",
    }),
  },

  watch: {
    allCourse: function(val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
        if (this.$route.params.id == undefined) {
          this.code = `LKI01-` + this.$store.getters["necessary/getCodePage"];

        } else {
          this.code = `LKI01-` + this.$route.params.id;
        }
        this.checkNull(val);
        this.checkPicture();
      }
      this.loading = false;
    },
    getUserTemplate: function(val) {
      this.condition =
        typeof val.data.condition.criteriaType == "undefined" ||
        val.data.condition.criteriaType.length == 0
          ? []
          : [
              {
                criteria: val.data.condition.criteriaType[0].criteria._id,
                val: val.data.condition.criteriaType[0].val,
              },
            ];
    },
  },

  mounted() {
    let body = {};
    this.lang = this.$store.state.language.language;
    if (this.$route.params.id == undefined) {
      body.templateCode =
        `LKI01-` + this.$store.getters["necessary/getCodePage"];
    } else {
      body.templateCode = `LKI01-` + this.$route.params.id;
    }
    if (body.templateCode == "LKI01-23") {
      this.$store.commit("necessary/setClearScore", 0);
    }

    body.code = this.courseCode;
    this.$store.dispatch("template/fetchContent", body);
  },

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.startTime = this.$helpers.getDateFormat();
  },
  beforeDestroy() {},
  methods: {
    checkNull(val) {
      var data = val.content.item[0].title[0].value;
      if (data) {
        this.cardType2 = "text";
      } else {
        this.cardType2 = "img";
      }
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    updateUser(path) {
      // let str = tempId.split("-");
      // let body = "/" + str[0] + "/" + str[1];
      // this.$store.commit("necessary/setCodePage", str[1]);
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseCode,
        template: this.content._id,
        section: this.$store.getters["necessary/getLerningCourse"].groups[0]
          .code,
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      });
      this.$router.push(path);
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    checkPicture() {
      var data = this.content.content.item[0].icon.enable.data;
      if (data === "/chinese/Image/ELEMENT/chest-open.png") {
        this.sound = "/chinese/Sound/Effect/Opening%20Chest/magic-wand.mp3";
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === "/chinese/Image/ITEM/paperroll/treasure-open.png") {
        this.sound = "/chinese/Sound/Effect/Opening%20Chest/magic-wand.mp3";
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === "/chinese/Image/ELEMENT/chest-closed.gif") {
        this.sound = "/chinese/Sound/Effect/Opening%20Chest/magic-wand.mp3";
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === "/chinese/Image/CHARACTER/FINAL/pegion_new.png") {
        this.sound = "/chinese/Sound/Effect/short-pigeon-wing-flap.mp3";
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      } else if (data === "/chinese/Image/ELEMENT/pegion_new.png") {
        this.sound = "/chinese/Sound/Effect/short-pigeon-wing-flap.mp3";
        var sound = this.baseUrl + this.sound;
        this.playSound(sound);
      }
    },
  },
};
</script>
<style></style>
